import React from "react";
import { ReactComponent as FailImg } from "../../../assets/illustrations/kyc-fail-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";

export const VerificationFailedPage: React.FC = () => {
  return (
    <ServicesLayout image={<FailImg />} title="Verification failed!">
      <div className="text-base theme-text-secondary">
        Unfortunately we have been unable to complete your verification. Please
        try again or contact support@archway.finance
      </div>
    </ServicesLayout>
  );
};
